import React from "react";
import PageContainer from "../../components/container/Container";
import nvidiaLogo from "../../assets/images/partners/nvidia-logo-0.png";
import graphanaLogo from "../../assets/images/partners/1200px-Grafana_logo.svg-1004x1024.png";
import awsLogo from "../../assets/images/partners/Amazon-Web-Services-AWS-Logo-Transparent-PNG.png";
import partnerImg from "../../assets/images/Banner_imgs/partnership.jpg";

function Partners() {
  return (
    <PageContainer
      title={"Strategic Partnerships - CodeElan Technologies"}
      description={"Discover our strategic partnerships with industry leaders like NVIDIA, AWS, and Grafana that enable us to deliver cutting-edge AI/ML and cloud solutions."}
    >
      {/* Hero Section */}
      <section className="hero-section contact-hero">
        <div className="hero-background">
          <div className="hero-overlay"></div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-8 mx-auto text-center">
                <div className="hero-content">
                  <div className="hero-accent"></div>
                  <h1 className="hero-title">
                    Our <span className="text-primary">Strategic Partners</span>
                  </h1>
                  <p className="hero-subtitle">
                    Collaborating with industry leaders to deliver cutting-edge technology solutions
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Partners Section */}
      <section className="section">
        <div className="container">
          <div className="row justify-content-center mb-5">
            <div className="col-lg-8 text-center">
              <h2 className="section-title">Technology Partnerships</h2>
              <p className="section-subtitle">
                Our strategic partnerships with industry leaders enable us to deliver innovative solutions and cutting-edge technology to our clients
              </p>
            </div>
          </div>
          
          {/* NVIDIA Partner */}
          <div className="row align-items-center mb-5">
            <div className="col-lg-4 text-center mb-4 mb-lg-0">
              <div className="partner-logo-card">
                <img src={nvidiaLogo} alt="NVIDIA" className="img-fluid partner-logo" />
              </div>
            </div>
            <div className="col-lg-8">
              <div className="partner-content">
                <h3 className="partner-title">NVIDIA</h3>
                <p className="partner-description">
                  NVIDIA's Computer Vision AI leverages GPUs to power advanced
                  image and video analysis. It enables CodeElan's platform
                  applications like autonomous vehicles, medical imaging, and
                  smart cities by training convolutional neural networks (CNNs)
                  for tasks such as object detection, segmentation, and
                  classification.
                </p>
              </div>
            </div>
          </div>

          {/* AWS Partner */}
          <div className="row align-items-center mb-5">
            <div className="col-lg-8 order-2 order-lg-1">
              <div className="partner-content">
                <h3 className="partner-title">Amazon Web Services (AWS)</h3>
                <p className="partner-description">
                  AWS Computer Vision services, like Amazon Rekognition, use AI to
                  analyze images and videos. With the help of this, CodeElan's
                  platform is enabled to carry out tasks such as object detection,
                  facial recognition, and content moderation. These services are
                  scalable, reliable, and integrate seamlessly with other AWS
                  offerings, enhancing applications in security, cloud
                  infrastructure, healthcare, and more.
                </p>
              </div>
            </div>
            <div className="col-lg-4 text-center mb-4 mb-lg-0 order-1 order-lg-2">
              <div className="partner-logo-card">
                <img src={awsLogo} alt="AWS" className="img-fluid partner-logo" />
              </div>
            </div>
          </div>

          {/* Grafana Partner */}
          <div className="row align-items-center mb-5">
            <div className="col-lg-4 text-center mb-4 mb-lg-0">
              <div className="partner-logo-card">
                <img src={graphanaLogo} alt="Grafana" className="img-fluid partner-logo" />
              </div>
            </div>
            <div className="col-lg-8">
              <div className="partner-content">
                <h3 className="partner-title">Grafana</h3>
                <p className="partner-description">
                  Grafana provides powerful monitoring and observability solutions
                  that enable CodeElan to deliver comprehensive insights and
                  analytics for our clients' applications. With Grafana's
                  advanced visualization capabilities, we can monitor system
                  performance, track metrics, and provide real-time dashboards
                  for better decision-making and operational efficiency.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section cta-section">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h2 className="section-title">Ready to Partner with Us?</h2>
              <p className="section-subtitle">
                Let's discuss how our technology partnerships can benefit your business
              </p>
              <div className="cta-buttons">
                <a href="/contactus" className="btn btn-primary btn-lg">
                  Get In Touch
                </a>
                <a href="/aboutus" className="btn btn-outline-primary btn-lg ms-3">
                  Learn More About Us
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </PageContainer>
  );
}

export default Partners;
